export default __webpack_public_path__ + "static/media/smiling-female-sitting-with-laptop.2a754ea4.png";